import { Button, FormControlLabel, FormGroup, Grid, InputAdornment, TextField } from "@mui/material";
import React, {useEffect, useState} from "react";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
    ProductBlockContainer,
    StyledButtonAddToShoppingCard,
    StyledCurrency,
    StyledMenuItem,
    StyledSection,
    StyledTypography,
    StyledTypographyPrice,
    WrapperSectionContent
} from "@features/shared/ProductBlock/styledComponents";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";
import {calculateCost, calculateCostV2, calculateTotalPrice, calculateTotalPriceArea} from "@helper/utils";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useDispatch } from 'react-redux';
import { addItem } from '@services/reducers/basketSlice';
import { StyledTypographyFilter } from "@features/shared/styledComponents";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import {TextFieldInput, TextFieldInputCount} from "@features/shared/ProductBlock/shared";

export const ProductBlockMoskito = ({ product }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();

    const [isLoading, setIsLoading] = useState(false);
    const [selectedWidth, setSelectedWidth] = useState(200);
    const [selectedLength, setSelectedLength] = useState(200);
    const [lengthError, setLengthError] = useState({height: false, width: false});
    const [currentPrice, setCurrentPrice] = useState(product.price[0].price);
    const [additionalPriceChecked, setAdditionalPriceChecked] = useState([]);
    const [selectedCounts, setSelectedCounts] = useState(product?.additionalPrice?.map(() => 1));
    const [buttonText, setButtonText] = useState("Додати в кошик");

    const handleWidthChange = (event) => {
        if (event.target.value >= 200 && event.target.value <= 2500) {
            setLengthError({...lengthError, width: false});
        } else {
            setLengthError({...lengthError, width: true});
        }
        setSelectedWidth(Number(event.target.value));
    };

    const handleCountChange = (event, index) => {
        const value = event.target.value;
        const newCounts = [...selectedCounts];
        newCounts[index] = value;
        setSelectedCounts(newCounts);
    };

    const from = state?.from || '/mosquitoNets';

    const handleBackToList = () => navigate(from);

    const handleLengthChange = (event) => {
        if (event.target.value >= 200 && event.target.value <= 2500) {
            setLengthError({...lengthError, height: false});
        } else {
            setLengthError({...lengthError, height: true});
        }
        setSelectedLength(Number(event.target.value));
    };

    const handleChangeAdditionalPrice = (event) => {
        const additionalPriceObject = product.additionalPrice.find(item => item._id === event.target.name);

        if (event.target.checked) {
            setAdditionalPriceChecked([...additionalPriceChecked, additionalPriceObject]);
        } else {
            setAdditionalPriceChecked(additionalPriceChecked.filter(item => item._id !== event.target.name));
        }
    };

    const getSelectedLengthError = lengthError => lengthError < 200 ?
        "мінімальна довжина 200 міліметрів" :
        "максимальна довжина 2500 міліметрів";

    const handleButtonClick = () => {
        const uniqueId = `${product._id}_${new Date().getTime()}`;

        const item = {
            uniqueId,
            id: product._id,
            img: product.image.url,
            name: product.name,
            quantity: 1,
            selectedLength,
            selectedWidth,
            additionalPriceChecked,
            finalPrice:  calculateTotalPriceArea(currentPrice, additionalPriceChecked, selectedCounts),
        }


        if (buttonText === 'Оформити замовлення') {
            navigate('/basket');
        } else {
            setIsLoading(true);
            setTimeout(() => {
                dispatch(addItem(item));
                setIsLoading(false);
                setButtonText("Оформити замовлення");
            }, 1000);
        }
    };

    const allVariantsAreNone = (config) => config.every(item => item.variant === "None");
    const isMainState = buttonText === 'Додати в кошик';

    useEffect(() => {
        const newPrice = calculateCostV2(
            selectedWidth,
            selectedLength,
            product?.price[0]?.price,
            additionalPriceChecked,
            selectedCounts
        );
        setCurrentPrice(newPrice);
    }, [selectedWidth, selectedLength, product, additionalPriceChecked, selectedCounts]);

    return (
        <ProductBlockContainer container spacing={2}>
            <Grid item xl={4} lg={5} md={12} sm={12}>
                <img
                    src={`${product?.image?.url}`}
                    alt={product.title}
                    loading="lazy"
                    width="100%"
                />
            </Grid>
            <Grid item xl={8} lg={7} md={12} sm={12}>
                <StyledTypography as="h2">{product.name}</StyledTypography>
                {!allVariantsAreNone(Object.values(product.config)) && <>
                    <StyledSection item xs={12}>Характеристики</StyledSection>
                    <WrapperSectionContent>
                        {Object.values(product.config).map((item, index) => {
                            if (item.variant === "None") return null;
                            return (
                                <Grid container key={`${item._id}-${index}`}>
                                    <StyledTypographyFilter bold={true}>{item.type}:</StyledTypographyFilter>
                                    <StyledTypographyFilter>{item.variant}</StyledTypographyFilter>
                                </Grid>
                            );
                        })}
                    </WrapperSectionContent>
                </>}
                <StyledSection item xs={12}>Розміри та додаткові послуги</StyledSection>

                <StyledTypographyFilter>
                    Введіть розміри сітки. Система автоматично підрахує вартість згідно
                    вказаних розмірів.
                </StyledTypographyFilter>
                <Grid mt={2} mb={2}>
                    <TextFieldInput
                        selectedLength={selectedWidth}
                        handleLengthChange={handleWidthChange}
                        lengthError={lengthError.width}
                        getSelectedLengthError={getSelectedLengthError}
                        title='введіть ширину в міліметрах:'
                    />
                    <TextFieldInput
                        selectedLength={selectedLength}
                        handleLengthChange={handleLengthChange}
                        lengthError={lengthError.height}
                        getSelectedLengthError={getSelectedLengthError}
                        title='введіть висоту в міліметрах:'
                    />
                </Grid>

                <FormGroup>
                    {product?.additionalPrice?.map((item, index) => (
                        <Grid container alignItems="center" key={item._id}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={additionalPriceChecked.some((checkedItem) => checkedItem._id === item._id)}
                                        onChange={(event) => handleChangeAdditionalPrice(event, index)}
                                        name={item._id}
                                    />
                                }
                                label={<Typography sx={{ color: theme.palette.primary.main }}>{item.additionally}</Typography>}
                            />
                            <TextFieldInputCount
                                selectedCount={selectedCounts[index]}
                                handleCountChange={(event) => handleCountChange(event, index)}
                                lengthError={lengthError}
                                getSelectedLengthError={getSelectedLengthError}
                                title=""
                            />
                        </Grid>
                    ))}
                </FormGroup>

                <StyledSection item xs={12}>Ціна</StyledSection>
                <Grid container mt={1}>
                    {!isMainState &&
                        <Button startIcon={<ArrowBackIcon />} onClick={handleBackToList}>Продовжити покупки</Button>
                    }
                    {isMainState &&
                        <>
                            <StyledTypographyPrice>
                                {lengthError.width || lengthError.height ? "0" : currentPrice}
                            </StyledTypographyPrice>
                            <StyledCurrency>грн</StyledCurrency>
                        </>
                    }
                    <StyledButtonAddToShoppingCard
                        loading={isLoading}
                        onClick={handleButtonClick}
                        disabled={lengthError.width || lengthError.height}
                        variant="contained"
                        isMainState={isMainState} // передаємо isMainState як пропс
                    >
                        <ShoppingCartIcon sx={{ marginRight: 1 }} /> {buttonText}
                    </StyledButtonAddToShoppingCard>
                </Grid>
            </Grid>
        </ProductBlockContainer>
    );
};
